/**
 * Label print option shared by every label modal: print one label across the
 * whole chosen size, or split it into 2 equal labels side by side (2-up roll),
 * the same label printed on both.
 */
export function LabelsPerRowToggle({
  value,
  onChange,
  w,
  h,
}: {
  value: 1 | 2;
  onChange: (v: 1 | 2) => void;
  /** The whole chosen size (both labels together), in mm. */
  w: number;
  h: number;
}) {
  const mm = (n: number) => (Number.isInteger(n) ? String(n) : n.toFixed(1));
  const options: { v: 1 | 2; label: string; sub: string }[] = [
    { v: 1, label: '1 label', sub: `whole ${mm(w)} × ${mm(h)} mm` },
    { v: 2, label: '2 labels', sub: `${mm(w / 2)} × ${mm(h)} mm each` },
  ];
  return (
    <div className="mt-3">
      <div className="mb-1.5 text-[11px] font-bold text-[var(--text-secondary)]">Labels in this size</div>
      <div className="grid grid-cols-2 gap-2">
        {options.map((o) => (
          <button
            key={o.v}
            type="button"
            onClick={() => onChange(o.v)}
            className="rounded-lg border px-3 py-1.5 text-[11px] font-bold transition"
            style={{
              background: value === o.v ? 'var(--accent)' : 'var(--bg-card)',
              color: value === o.v ? '#000' : 'var(--text-secondary)',
              borderColor: value === o.v ? 'var(--accent)' : 'var(--border-color)',
            }}
          >
            {o.label}
            <span className="block text-[10px] font-semibold opacity-75">{o.sub}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
